const brandName = process.env.REACT_APP_BRAND_NAME || 'Legal Review';

export const branding = {
  name: brandName,
  referralNetwork: `${brandName} referral network`,
};
